import React, { useEffect, useState } from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';
import { useSelector } from 'react-redux';
import History from 'Store/history';
import EnvironmentManager from 'Utils/environmentManager';
import AsyncNotFound from 'Pages/NotFound';

const VaixSearch = loadable(() => pMinDelay(import('./VaixSearch'), 300), {
  fallback: <Loading />
});
const AsyncVaixSearch = props => {
  const { isAuthenticated } = useSelector(state => state.auth);
  const [isSearchEnabled, setIsSearchEnabled] = useState(undefined);

  useEffect(() => {
    if (!isAuthenticated) {
      History.replace('/giris-yap');
    }
  }, [isAuthenticated]);

  useEffect(() => {
    let isMounted = true;
    const resolveToggle = async () => {
      await EnvironmentManager.waitForMessages();
      if (!isMounted) return;
      const toggleValue = EnvironmentManager.getMessageText({ key: 'main_page_search_toggle' });
      if (toggleValue === 'true') {
        setIsSearchEnabled(true);
      } else if (toggleValue === 'false') {
        setIsSearchEnabled(false);
      } else {
        setIsSearchEnabled(false);
      }
    };
    resolveToggle();
    return () => {
      isMounted = false;
    };
  }, []);

  const pageConfig = {
    headerType: props.userAgent?.device?.type === 'desktop' ? 'full' : 'mobile-none',
    footerType: props.userAgent?.device?.type === 'desktop' ? 'full' : 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent?.device?.type } hide-betslip hide-sticky-navigation`
      }
    }
  };

  if (!isAuthenticated) {
    return <Loading />;
  }

  if (typeof isSearchEnabled === 'undefined') {
    return <Loading />;
  }

  if (!isSearchEnabled) {
    return <AsyncNotFound { ...props } />;
  }

  return (
    <ApplicationLayout { ...pageConfig } { ...props } showVaixSearch={ true }>
      <VaixSearch { ...props } />
    </ApplicationLayout>
  );
};

AsyncVaixSearch.propTypes = {
  userAgent: PropTypes.object,
  match: PropTypes.object
};

export default AsyncVaixSearch;
